// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__KxhEl","tuyaListBody":"tuyaListBody__MjtcX"};